import React, { FC, useState } from 'react'
import { IonFooter, IonContent, IonPage, useIonViewWillEnter } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { orderMobx } from 'restaurant'
import { toPrice, classNames } from '@dt/fe-utils'
import { modalLayer, showMsg, useHistoryNew } from '@utils'
import ProductItems from '../components/ProductItems'
import Discount from '../components/Discount'
import { observer } from 'mobx-react'
import { Icon, UseTextArea } from '@cps'
import OrderAPI from '@api/order.api'
import ReasonsModal from '../modal/ReasonsModal'
import { refundMobx } from '@mobx/order'
import './index.scss'

interface IProps extends RouteComponentProps { }

const Refund: FC<IProps> = ({ match }) => {
  const { ordersId } = match.params as any
  const viewOrder = orderMobx.viewOrder
  const [reason, setReason] = useState('')
  const [reasonInput, setReasonInput] = useState('')
  const history = useHistoryNew()

  const handleCancel = () => {
    if (history.getPrevState()) {
      history.goBack()
    } else {
      history.replace('/orders')
    }
  }
  const handleConfirm = async () => {
    if (!reason) return
    try {
      const res = await OrderAPI.applyMobileRefund({ storeId: viewOrder.storeId, ordersId, refundReason: reason, message: reasonInput })
      if (!res.error) {
        history.replace(`/refund/detail/${ordersId}`)
      } else {
        setTimeout(() => {
          handleCancel()
        }, 3000)
        showMsg(res?.message, 3000)
      }
    } catch (error) {
      showMsg(error.message, 3000)
    }
  }

  const handleReasonInput = (value) => {
    setReasonInput(value)
  }

  const handleReasonModal = () => {
    modalLayer(ReasonsModal, {
      data: reason
    }).then((res: any) => {
      setReason(res)
    })
  }

  const initOrder = () => {
    if (viewOrder.ordersId !== ordersId) {
      orderMobx.init(ordersId).then((info) => {
      }).catch((err: any) => {
        console.log(err)
      })
    }
  }
  useIonViewWillEnter(() => {
    initOrder()
    refundMobx.getMobileRefundPlan()
  })
  return (
    <IonPage className='order-refund-page'>
      <IonContent>
        <div className='order-refund-content'>
          <div className='refund-item-wrapper'>
            <div className='title-wrapper'>{i18n.t('refund.product')}</div>
            <ProductItems />
            <Discount />
          </div>
        </div>
        <div className='order-refund-content'>
          <div className='refund-item-wrapper'>
            <div className='title-wrapper'>
              <span>{i18n.t('refund.refundReasonTitle')}</span>
              <div className='right-wrap' onClick={handleReasonModal}>
                <span className={classNames('refund-reason', { error: !reason })}>{reason || i18n.t('refund.refundReasonSelect')}</span>
                <Icon name='chevron-right' />
              </div>
            </div>
            <div className='refund-item-content'>
              <UseTextArea
                maxLength={170}
                value={reasonInput}
                placeholder={i18n.t('refund.refundReasonPlaceHolder')}
                onChange={handleReasonInput}
              />
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <div className='footer-btn'>
          <div className='cancel' onClick={handleCancel}>{i18n.t('refund.refundCancel')}</div>
          <div className={classNames('confirm', { disabled: !reason })} onClick={handleConfirm}>{i18n.t('refund.refundFeeConfirm', { price: toPrice(viewOrder.totalPrice) })}</div>
        </div>
      </IonFooter>
    </IonPage>
  )
}
export default observer(Refund)
